import { decodeBase64 } from "./base64"

// deserializeAssets takes a list of base64 encoded
// assets and returns them deserialized
export const deserializeAssets = (data: any[]) => {
  const assistedAssets = data.filter(item => {
     const json = JSON.parse(decodeBase64(item.source))
     return json.type !== 'a8solo'
  })

  const assets = assistedAssets.reduce((acc: any, cur: any) => {
    const json = JSON.parse(decodeBase64(cur.source))
    acc[cur.asset_id] =
      json.data && json.data.assetId
        ? json.data
        : {
            id: cur.id,
            label: cur.label,
            orgId: cur.org_id,
            assetId: cur.asset_id,
            json,
          }
    return acc
  }, {})

  return assets
}
